"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = filterElementsByType;
function filterElementsByType(elements, type) {
    var value = null;

    if (elements && elements.some(function (x) {
        return x.type === type;
    })) {
        value = elements.filter(function (x) {
            return x.type === type;
        });
    }

    return value;
}